module.exports = __webpack_public_path__ + "media/bootstrap_theme/close-1f83a25c.png";